export default __webpack_public_path__ + "static/media/emilse-bg.7453ccb7.png";